import React from "react";

const ChooseModelIcon = ({ fill }) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42.7031 0.703125C43.8698 0.703125 44.9271 1.17708 45.875 2.125C46.8229 3 47.2969 4.05729 47.2969 5.29688V12.4062C47.2969 13.2083 47.0781 13.974 46.6406 14.7031C46.2031 15.3594 45.6562 15.9062 45 16.3438V42.7031C45 43.5052 44.7448 44.2708 44.2344 45C43.7969 45.7292 43.2135 46.3125 42.4844 46.75C41.7552 47.1146 41.026 47.2969 40.2969 47.2969H7.70312C6.97396 47.2969 6.24479 47.1146 5.51562 46.75C4.78646 46.3125 4.16667 45.7292 3.65625 45C3.21875 44.2708 3 43.5052 3 42.7031V16.3438C2.34375 15.9062 1.79688 15.3594 1.35938 14.7031C0.921875 13.974 0.703125 13.2083 0.703125 12.4062V5.29688C0.703125 4.05729 1.17708 3 2.125 2.125C3.07292 1.17708 4.13021 0.703125 5.29688 0.703125H42.7031ZM31 28.7031V24H17V28.7031H31ZM42.7031 12.2969V5.29688H5.29688V12.2969H42.7031Z"
      fill={fill || "#7EC7BD"}
    />
  </svg>
);

export default ChooseModelIcon;
